// src/hooks/useUserActivitiesData.js
import { useState, useEffect, useMemo } from 'react';
import { toast } from 'react-toastify';
import SubAccountantService from '../Services/subAccountant.service.js';
import ClientService        from '../Services/client.service.js';

/**
 * Fetches sub-accountants, clients, and provides a static list of activity types.
 */
export default function useUserActivitiesData(user, token) {
  const [subAccountants, setSubAccountants] = useState([]);
  const [clients, setClients]               = useState([]);
  const [loading, setLoading]               = useState(false);

  useEffect(() => {
    if (!user?.accountantId) return;

    async function fetchFilters() {
      setLoading(true);
      try {
        // get sub-accountants + include main accountant as “self”
        const subs   = await SubAccountantService.GetSubAccountantByAccountantId(token, user.accountantId);
        const main   = await SubAccountantService.GetAccountantById(token, user.accountantId);
        const allSubs = [{ value: main.accountantId, label: main.name }, 
                         ...(subs || []).map(s => ({ value: s.subAccountantId, label: s.name }))];
        setSubAccountants(allSubs);

        // get minimal clients
        const clientsRes = await ClientService.GetMinimalClients(user.accountantId, token, 1, 1000, true);
        const clientOpts = [
          { value: null, label: 'Office' },
          ...(clientsRes.clients || []).map(c => ({ value: c.caseId, label: c.name }))
        ];
        setClients(clientOpts);
      } catch (err) {
        console.error(err);
        toast.error('Failed to load filter data');
      } finally {
        setLoading(false);
      }
    }

    fetchFilters();
  }, [user, token]);

  const activities = useMemo(() => [
    { value: 1,  label: 'Upload' },
    { value: 2,  label: 'Download' },
    { value: 3,  label: 'ViewData' },
    { value: 4,  label: 'GenerateDocument' },
    { value: 5,  label: 'ImportData' },
    { value: 6,  label: 'ExportData' },
    { value: 7,  label: 'Other' },
    { value: 8,  label: 'CreateEntities' },
    { value: 9,  label: 'DeleteData' },
    { value: 10, label: 'EditData' },
  ], []);

  return { subAccountants, clients, activities, loading };
}
